declare let L:any;

const pinLocation = "/img/leaflet/marker-icon.png";

class MapDivIcon {
    private _title = '';
    private _image = '';

    public constructor(title: string, image: string = null) {
        this._title = title;
        this._image = image;
    }

    get title(): string {
        return this._title;
    }

    set title(value: string) {
        this._title = value;
    }

    get image(): string {
        return this._image;
    }

    set image(value: string) {
        this._image = value;
    }

    public getDivIcon(hidePin: boolean = false) {
        return new L.DivIcon({
            className: 'icen-helper-icon',
            html: this.getHTML(hidePin)
        });
    }

    private getHTML(hidePin: boolean) {
        let html = '';
        if (this._image)
            html += '<img src="' + this._image + '" class="icon-additional-img" />';

        if (!hidePin)
            html += '<img src="' + pinLocation + '" class="leaflet-marker-icon-icen" />';

        if (this._title)
            html += '<span class="icon-title">' + this._title + '</span>';

        return html;
    }
}

export default MapDivIcon;